import * as functions from './index';

export class FunctionLoader {
  private readonly _namespacedFunctions: Record<string, () => unknown> = {};

  constructor() {
    this.loadFunctions();
  }

  get functions(): Record<string, () => unknown> {
    return this._namespacedFunctions;
  }

  private loadFunctions(): void {
    for (const [namespace, namespacedFunctions] of Object.entries(functions)) {
      for (const [functionName, functionInstance] of Object.entries(namespacedFunctions)) {
        if (typeof functionInstance === 'function') {
          // concatenate namespace with capitalized function names (e.g. date.add -> dateAdd)
          const upperCasedFunctionName = functionName.charAt(0).toUpperCase() + functionName.slice(1);
          this._namespacedFunctions[`${namespace}${upperCasedFunctionName}`] = functionInstance as () => unknown;
        }
      }
    }
  }
}
